require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/es6.array.species.js
// module id = 853
// module chunks = 32